// extracted by mini-css-extract-plugin
module.exports = {"email":"Fq","desktop":"Gq","mobile":"Hq","hidden":"Iq","visible":"Jq"};